var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { PageLayout } from '../../Components/PageLayout';
import styled from 'styled-components';
import { EMPTY_FOOTER_HEIGHT, HEADER_HEIGHT, WIDGET_HEIGHT, } from '../../../constanst';
import { customScrollBar } from '../../Components/cssTemplates/ScrollBar';
import { observer } from 'mobx-react-lite';
import { useApplication } from '../../Contexts/ApplicationContext';
var StyledIframe = styled.iframe(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  border: none;\n  height: 1500px;\n"], ["\n  width: 100%;\n  border: none;\n  height: 1500px;\n"])));
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow: auto;\n  height: ", "px;\n\n  ", "\n"], ["\n  overflow: auto;\n  height: ", "px;\n\n  ", "\n"])), WIDGET_HEIGHT - HEADER_HEIGHT - EMPTY_FOOTER_HEIGHT, customScrollBar);
export var PaymentFrame = observer(function (_a) {
    var url = _a.url;
    var updateStepsInfo = useApplication().orderFacade.updateStepsInfo;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var messageListener = useCallback(function (e) {
        if (e.data === 'orderPageOpen') {
            setLoading(true);
            updateStepsInfo();
        }
    }, [updateStepsInfo]);
    useEffect(function () {
        window.addEventListener('message', messageListener);
        return function () { return window.removeEventListener('message', messageListener); };
    }, [messageListener]);
    return (_jsx(PageLayout, __assign({ loading: loading, hideHeaderChip: true }, { children: url && !loading && (_jsx(Wrapper, { children: _jsx(StyledIframe, { scrolling: "no", title: "payment", src: url }) })) })));
});
var templateObject_1, templateObject_2;
